export const APPS_LIST = "APPS_LIST";
export const APPS_CREATE = "APPS_CREATE";
export const APPS_UPDATE = "APPS_UPDATE";
export const APPS_DELETE = "APPS_DELETE";
export const APPS_SHOW = "APPS_SHOW";
export const DEVICE_TYPE_LIST = "DEVICE_TYPE_LIST";
